import { lastestVersion, legalVersion, compareArr } from 'src/utils/version'
import * as T from './types'

export default {
    [T.SET_APP_BASE](state, payload) {
        state.base = payload || {}
    },
    [T.UPDATE_APP_BASE](state, payload) {
        if (state.base.id !== payload.id) return
        state.base = {
            ...state.base,
            ...payload
        }
    },
    [T.SET_APP_VERSIONS](state, payload) {
        state.appVersion = payload
    },
    [T.SET_ALL_PUBLISHED_APP_VERSIONS](state, payload) {
        state.allPublishedAppVersions = payload
    },
    [T.SET_ALL_APP_VERSIONS](state, payload) {
        state.allAppVersions = payload
    },
    [T.SET_LAST_APP_VERSIONS](state, payload) {
        state.lastAppVersions = payload.webapp_version
        state.lastAppShellVersions = payload.shell_version
    },
    [T.SET_ALL_ENGINE_VERSIONS](state, payload = []) {
        const allEngineRemarks = {}
        const legalArr = []
        const illegalArr = []
        payload.forEach(item => {
            allEngineRemarks[item.version] = item.remark
            if (item.is_recommended) {
                state.engineRecommended = item || {}
            }
            if (legalVersion(item.version)) {
                legalArr.push(item)
            } else {
                illegalArr.push(item)
            }
        })

        // 兼容测试环境某些不合法的版本号
        // 避免测试报 bug
        legalArr.sort((current, next) => (lastestVersion(current.version, next.version) ? -1 : 1))
        illegalArr.sort((current, next) => {
            const currentArr = current.version.split('.')
            const nextArr = next.version.split('.')
            return compareArr(currentArr, nextArr) ? -1 : 1
        })
        state.allEngineRemarks = allEngineRemarks
        state.allEngineVersions = legalArr.concat(illegalArr)
    },
    [T.SET_LAST_ENGINE_VERSIONS](state, payload) {
        state.lastEngineVersions = payload
    },
    [T.ADD_APP_BUILD](state, { env, versionId, buildId }) {
        if (!state.allBuildQueue[env].find(item => item.versionId === versionId && item.buildId === buildId)) {
            state.allBuildQueue[env].push({ versionId, buildId })
            localStorage.setItem('allBuildQueue', JSON.stringify(state.allBuildQueue))
        }
    },
    [T.REMOVE_APP_BUILD](state, { env, versionId, buildId }) {
        const index = state.allBuildQueue[env].findIndex(item => item.versionId === versionId && item.buildId === buildId)
        if (index > -1) {
            state.allBuildQueue[env].splice(index, 1)
            localStorage.setItem('allBuildQueue', JSON.stringify(state.allBuildQueue))
        }
    },

    [T.SET_TENANT_LIST](state, payload) {
        state.tenantList = payload
    },

    [T.SET_TENANT_UPDATE_INFO](state, payload) {
        state.tenantUpdateInfo = payload
    },

    [T.SET_TENANT_VERSIONS](state, payload) {
        state.tenantVersions = payload
    },
    [T.SET_TENANT_UPDATE_VERSIONS](state, payload) {
        state.tenantUpdateVersions = payload
    },
    [T.SET_PARENT_APP_VERSIONS](state, payload) {
        state.parentAppVersions = payload
    },
}
